import "../../../styles/kjedeweb/singleChainProductListItem.scss";

import Icon, { iconColor, iconTypes } from "../../common/components/Icon.jsx";

import PropTypes from "prop-types";
import React from "react";
import moment from "moment";
import { toLocaleFixed } from "../../common/util/localization.jsx";

/**
 * Creates a node component, used to display value, futureValue, future date
 * @param {object} props 
 * @return {node}
 */
function FuturePriceItem({currentValue, futureEndValue, futureEndValueDate}) {
    const futureDate = !futureEndValueDate ? moment() : moment(futureEndValueDate);

    return (
        <div className="label14 product-view-list-item-future-price">
            <div className="content">
                {currentValue!=null &&  (
                    <div className="current-value" >{toLocaleFixed(currentValue,2)}</div>
                )}
                {futureEndValueDate!=null && futureEndValue!=null && (
                    <React.Fragment>
                        <div className="futureValue">
                            <Icon type={currentValue<futureEndValue ? iconTypes.arrowUp : iconTypes.arrowDown} color={iconColor.red} />
                            <div className="value">{toLocaleFixed(futureEndValue,2)}</div>
                        </div>
                        <div className="label10">{futureDate.format("DD.MM.YYYY")}</div>
                    </React.Fragment>
                )}
            </div>
        </div>
    );
}
FuturePriceItem.propTypes = {
    currentValue: PropTypes.number,
    futureEndValue: PropTypes.number,
    futureEndValueDate: PropTypes.string,
};

export default FuturePriceItem;